import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"
import { HasInvalidated } from "event-definitions"
import { makeBusyFunction } from "lib/@components/busy/make-busy-function"

export const setAssetRegistriesForRegime = api(
    makeBusyFunction(
        async function setAssetRegistriesForRegime(regime, registers) {
            return mutate(
                gql`
                    mutation SetAssetRegisters($regime: String!, $registers: [String!]!) {
                        setAssetRegistriesForRegime(regimeTree: $regime, registries: $registers)
                    }
                `,
                {
                    regime,
                    registers,
                },
                {
                    returns: "setAssetRegistriesForRegime",
                }
            )
        },
        "Setting Asset Registers",
        () => HasInvalidated("regimeAssetSummary").wait(5000)
    )
)
